(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-feature-hotspots-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-hotspot-index]');
    if (!button) return;

    const section = button.closest('[data-product-feature-hotspots]');
    if (!section) return;

    const index = button.getAttribute('data-hotspot-index');
    const buttons = section.querySelectorAll('[data-hotspot-index]');
    const cards = section.querySelectorAll('[data-hotspot-card]');

    buttons.forEach((item) => {
      item.setAttribute('aria-expanded', item === button ? 'true' : 'false');
    });

    cards.forEach((card) => {
      card.classList.toggle('is-active', card.getAttribute('data-hotspot-card') === index);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
